import {
  Column,
  PredicateModel,
  SortDescriptorModel,
} from "@syncfusion/ej2-react-grids";
import moment from "moment";

export function useGridFiltersModule() {
  const filterPredicateText = {
    and: "AND",
    or: "OR",
  };

  const filterOperatorText = {
    startswith: "Starts with",
    endswith: "Ends with",
    contains: "Contains",
    equal: "Equal to",
    notequal: "Not Equal to",
    greaterthan: "Greater than",
    greaterthanorequal: "Greater than or Equal To",
    lessthan: "Less than",
    lessthanorequal: "Less than or Equal To",
  };

  const valueOrEmpty = (value: string): string => {
    return ["", "null"].includes(value) ? "empty" : value;
  };

  // Sort
  const getSortDetails = (
    columns?: Column[],
    sorts?: SortDescriptorModel[]
  ) => {
    const sortDetails = sorts?.map((x) => ({
      field: String(x.field),
      details: getSortText(columns, x),
      direction: x.direction,
    }));

    return sortDetails;
  };

  const getSortText = (
    columns?: Column[],
    sort?: SortDescriptorModel
  ): string => {
    const col = columns?.find((x) => x.field === sort?.field);

    return `Order: ${col?.headerText}`;
  };

  // Filter
  const getFilterDetails = (filters?: PredicateModel[]) => {
    const distinctFields = filters
      ?.map((item) => item.field)
      .filter((value, index, self) => self.indexOf(value) === index);

    const filterDetails = distinctFields?.map((field) => ({
      field: String(field),
      details: getFilterText(filters, field),
    }));

    return filterDetails;
  };

  const formatValue = (
    value: string | number | Date | boolean | (string | number | boolean | Date)[] | undefined,
    type: string | undefined
  ): string => {
    if (Array.isArray(value)) {
      return value.map(v => formatValue(v, type)).join(", ");
    }
    if (type === "date") {
      return moment(String(value)).format("L");
    }

    return String(value);
  };

  const getFilterText = (
    filters?: PredicateModel[],
    field?: string
  ): string => {
    // Process Filter (Ex. [Equal to] [100] [OR] [Equal to] [1000])
    let details = "";
    const filterTextList: string[] = [];
    filters
      ?.filter((x) => x.field === field)
      .forEach((col, idx) => {
        const predicateText =
          idx > 0
            ? (filterPredicateText[
                col.predicate as keyof typeof filterPredicateText
              ] as string)
            : "";
        const operatorText =
          filterOperatorText[col.operator as keyof typeof filterOperatorText];
        const filterText = `${operatorText} ${valueOrEmpty(
          // @ts-ignore
          formatValue(col.value, col.type)
        )}`;

        // Remove any duplicate
        if (filterTextList.includes(filterText)) {
          return;
        }

        filterTextList.push(filterText);

        details += ` ${predicateText} ${filterText} `.trimStart();
      });

    return details;
  };

  return { getSortDetails, getFilterDetails };
}
